import { render, staticRenderFns } from "./SwitchUserWidget.vue?vue&type=template&id=13906b9e&"
import script from "./SwitchUserWidget.vue?vue&type=script&lang=js&"
export * from "./SwitchUserWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports